/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { JsonPipe } from '@angular/common';
import { Component, inject, OnInit, signal, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalculateValidationTextFn } from 'src/app/controls/components/internal/control-supporting-text/control-supporting-text.component';
import { CustomValidationService } from 'src/app/controls/services/custom-validation.service';
import { LayoutContainerComponent } from '../../controls/components/basic/layout-container/layout-container.component';
import { ContainerFluidDirective } from '../../controls/directives/container-fluid.directive';
import { LayoutRowComponent } from '../../controls/components/basic/layout-row/layout-row.component';
import { LayoutColumnComponent } from '../../controls/components/basic/layout-column/layout-column.component';
import { TextboxComponent } from '../../controls/components/basic/textbox/textbox.component';
import { XPathComponent } from '../../controls/components/advanced/xpath/xpath.component';
import { SingleselectboxComponent } from '../../controls/components/basic/singleselectbox/singleselectbox.component';
import { MultiselectboxComponent } from '../../controls/components/basic/multiselectbox/multiselectbox.component';
import { CheckboxComponent } from '../../controls/components/basic/checkbox/checkbox.component';
import { DatetimeboxComponent } from '../../controls/components/basic/datetimebox/datetimebox.component';
import { DatetimeboxDatetimeDirective } from '../../controls/directives/datetimebox-datetime.directive';
import { DatetimeboxDateDirective } from '../../controls/directives/datetimebox-date.directive';
import { DatetimeboxTimeDirective } from '../../controls/directives/datetimebox-time.directive';
import { ButtonComponent } from '../../controls/components/basic/button/button.component';
import { ButtonPrimaryDirective } from '../../controls/directives/button-primary.directive';
import { ButtonSubmitDirective } from '../../controls/directives/button-submit.directive';
import { ButtonSecondaryDirective } from '../../controls/directives/button-secondary.directive';
import { ButtonTertieryDirective } from '../../controls/directives/button-tertiery.directive';
import { ConditionalValidatorDirective } from '../../controls/directives/conditional-validator.directive';
import { PasswordComponent, PasswordComponentValue } from 'src/app/controls/components/basic/password/password.component';

@Component({
    selector: 'app-control-test',
    templateUrl: './control-test.component.html',
    styleUrls: ['./control-test.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, LayoutContainerComponent, ContainerFluidDirective, LayoutRowComponent, LayoutColumnComponent, TextboxComponent, XPathComponent, SingleselectboxComponent, MultiselectboxComponent, CheckboxComponent, DatetimeboxComponent, DatetimeboxDatetimeDirective, DatetimeboxDateDirective, DatetimeboxTimeDirective, ButtonComponent, ButtonPrimaryDirective, ButtonSubmitDirective, ButtonSecondaryDirective, ButtonTertieryDirective, ConditionalValidatorDirective, JsonPipe, PasswordComponent]
})
export class ControlTestComponent implements OnInit {
    @ViewChild('tForm')
    private templateForm: NgForm;
    private fb = inject(FormBuilder);

    allowShowPassword = signal(false);

    myData = {
        name: null,
        email: null,
        zip: null,
        city: null,
        allowShowPassword: null,
        passwordHash: null,
        passwordSecret: { id: '001c1d1fa3624f30b4491b4315cfa383', value: null } as PasswordComponentValue,
        xpath: null,
        backgroundColor: null,
        foregroundColor: null,
        moreColors: null,
        otherColors: null,
        receiveNewsletter: null,
        datetime: null,
        date: null,
        time: null,
    };

    colors: { id: string; name: string; }[] = null;

    reactiveFormGroup: FormGroup = this.fb.group({
        name: [this.myData.name, [Validators.pattern('[a-zA-Z ]*'), Validators.required, Validators.maxLength(10)]],
        email: [{ value: this.myData.email, disabled: false }, [Validators.email, CustomValidationService.conditionalValidator(() =>
            this.reactiveFormGroup?.get('receiveNewsletter').value === true, Validators.required)]],
        zip: this.myData.zip,
        city: [this.myData.city, CustomValidationService.conditionalValidator(() => this.reactiveFormGroup?.get('zip').value, Validators.required)],
        allowShowPassword: [this.myData.allowShowPassword],
        passwordHash: [this.myData.passwordHash],
        passwordSecret: [this.myData.passwordSecret],
        xpath: [this.myData.xpath, Validators.required],
        backgroundColor: { value: this.myData.backgroundColor, disabled: false },
        foregroundColor: [this.myData.foregroundColor, Validators.required],
        moreColors: [{ value: this.myData.moreColors, disabled: false }],
        otherColors: [this.myData.otherColors, Validators.required],
        receiveNewsletter: this.myData.receiveNewsletter,
        datetime: [this.myData.datetime, Validators.required],
        date: this.myData.date,
        time: this.myData.time,
    });

    constructor() {
        this.reactiveFormGroup.get('receiveNewsletter').valueChanges.subscribe(() => {
            this.reactiveFormGroup.get('email').updateValueAndValidity({ onlySelf: true });
        });

        this.reactiveFormGroup.get('zip').valueChanges.subscribe(() => {
            this.reactiveFormGroup.get('city').updateValueAndValidity({ onlySelf: true });
        });

        this.reactiveFormGroup.get('allowShowPassword').valueChanges.subscribe((value: boolean) => {
            this.allowShowPassword.set(value);
        });
    }

    ngOnInit(): void {
        this.refresh();
        this.reactiveFormPatch();
        this.reactiveFormGroup.disable();
        setTimeout(() => this.templateForm.form.disable());
    }

    refresh() {
        this.colors = [
            { id: 'ba', name: 'Black' },
            { id: 'bu', name: 'Blue' },
            { id: 'ge', name: 'Green' },
            { id: 'cy', name: 'Cyan' },
            { id: 're', name: 'Red' },
            { id: 'ma', name: 'Magenta' },
            { id: 'yl', name: 'Yellow' },
            { id: 'wi', name: 'White' },
        ];

        this.myData.name = 'John Doe';
        this.myData.email = 'john@example.com';
        this.myData.zip = '7100';
        this.myData.city = null;
        this.myData.allowShowPassword = false;
        this.myData.passwordHash = null;
        this.myData.passwordSecret = { id: '001c1d1fa3624f30b4491b4315cfa383', value: null } as PasswordComponentValue;
        this.myData.xpath = "/*[local-name()='custom-test-xml']/*[local-name()='whatever-id']";
        this.myData.backgroundColor = null;
        this.myData.foregroundColor = 'red';
        this.myData.moreColors = null;
        this.myData.otherColors = ['bu', 'ge', 're'];
        this.myData.receiveNewsletter = true;
        this.myData.datetime = new Date('2024-05-02T09:42:37Z');
        this.myData.date = new Date(1714600800000); // 2024-05-02T00:00:00+02:00
        this.myData.time = new Date(new Date().setHours(11, 37, 42)); // Today at 11:37:42 local time
    }

    getValidationText: CalculateValidationTextFn = control =>
        control?.errors?.pattern ? 'Name can only contain letters' : null;

    /*
    * REACTIVE FORM
    */

    reactiveFormEdit() {
        this.reactiveFormGroup.enable();
    }

    reactiveFormSubmit(): void {
        this.myData.name = this.reactiveFormGroup.get('name').value;
        this.myData.email = this.reactiveFormGroup.get('email').value;
        this.myData.zip = this.reactiveFormGroup.get('zip').value;
        this.myData.city = this.reactiveFormGroup.get('city').value;
        this.myData.xpath = this.reactiveFormGroup.get('xpath').value;
        this.myData.allowShowPassword = this.reactiveFormGroup.get('allowShowPassword').value;
        this.myData.passwordHash = this.reactiveFormGroup.get('passwordHash').value;
        this.myData.passwordSecret = this.reactiveFormGroup.get('passwordSecret').value;
        this.myData.backgroundColor = this.reactiveFormGroup.get('backgroundColor').value;
        this.myData.foregroundColor = this.reactiveFormGroup.get('foregroundColor').value;
        this.myData.moreColors = this.reactiveFormGroup.get('moreColors').value;
        this.myData.otherColors = this.reactiveFormGroup.get('otherColors').value;
        this.myData.receiveNewsletter = this.reactiveFormGroup.get('receiveNewsletter').value;
        this.myData.datetime = this.reactiveFormGroup.get('datetime').value;
        this.myData.date = this.reactiveFormGroup.get('date').value;
        this.myData.time = this.reactiveFormGroup.get('time').value;
        this.reactiveFormGroup.disable();
    }

    reactiveFormCancel() {
        this.reactiveFormPatch();
        this.reactiveFormGroup.markAsUntouched();
        this.reactiveFormGroup.markAsPristine();
        this.reactiveFormGroup.disable();
    }

    reactiveFormClear() {
        this.reactiveFormGroup.reset();
        this.reactiveFormGroup.markAsUntouched();
        this.reactiveFormGroup.markAsPristine();
    }

    reactiveFormPatch() {
        this.reactiveFormGroup.setValue({
            name: this.myData.name,
            email: this.myData.email,
            zip: this.myData.zip,
            city: this.myData.city,
            xpath: this.myData.xpath,
            allowShowPassword: this.myData.allowShowPassword,
            passwordHash: this.myData.passwordHash,
            passwordSecret: this.myData.passwordSecret,
            backgroundColor: this.myData.backgroundColor,
            foregroundColor: this.myData.foregroundColor,
            moreColors: this.myData.moreColors,
            otherColors: this.myData.otherColors,
            receiveNewsletter: this.myData.receiveNewsletter,
            datetime: this.myData.datetime,
            date: this.myData.date,
            time: this.myData.time,
        });
    }


    /*
    * TEMPLATE FORM
    */

    zipValidators = [Validators.required];
    zipCondition = () => this.templateForm?.value.zip;

    newsletterValidators = [Validators.required];
    newsletterCondition = () => this.templateForm?.value.receiveNewsletter;

    templateFormEdit() {
        this.templateForm.form.enable();
    }

    templateFormSubmit(): void {
        this.myData.name = this.templateForm.value.name;
        this.myData.email = this.templateForm.value.email;
        this.myData.zip = this.templateForm.value.zip;
        this.myData.city = this.templateForm.value.city;
        this.myData.xpath = this.templateForm.value.xpath;
        this.myData.passwordHash = this.templateForm.value.passwordHash;
        this.myData.passwordSecret = this.templateForm.value.passwordSecret;
        this.myData.backgroundColor = this.templateForm.value.backgroundColor;
        this.myData.foregroundColor = this.templateForm.value.foregroundColor;
        this.myData.moreColors = this.templateForm.value.moreColors;
        this.myData.otherColors = this.templateForm.value.otherColors;
        this.myData.receiveNewsletter = this.templateForm.value.receiveNewsletter;
        this.myData.datetime = this.templateForm.value.datetime;
        this.myData.date = this.templateForm.value.date;
        this.myData.time = this.templateForm.value.time;
        this.templateForm.form.disable();
    }

    templateFormCancel() {
        this.templateForm.reset(this.myData);
        this.templateForm.form.markAsUntouched();
        this.templateForm.form.markAsPristine();
        this.templateForm.form.disable();
    }

    templateFormClear() {
        this.templateForm.form.reset();
    }

    updateValidation(components: any[]) {
        components.forEach(component => component.ngControl.control.updateValueAndValidity());
    }
}
